var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgActivity1 = function SvgActivity1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.335 2.081a.8.8 0 0 1 .252.084l.115.071.1.09a.8.8 0 0 1 .152.218L10 2.67l.002.006 4.795 17.063 1.84-6.54.06-.192a2.47 2.47 0 0 1 2.317-1.609h2.314a.6.6 0 0 1 0 1.2h-2.315a1.27 1.27 0 0 0-1.221.925L15.6 21.32l-.002.006a.833.833 0 0 1-1.6 0l-.001-.006L9.2 4.257l-1.838 6.542a2.47 2.47 0 0 1-2.367 1.8H2.67a.6.6 0 0 1 0-1.2h2.322a1.266 1.266 0 0 0 1.215-.924l2.192-7.8.002-.005a.83.83 0 0 1 .3-.434l.113-.071a.83.83 0 0 1 .387-.095z"
  })));
};
export default SvgActivity1;